module.exports = __webpack_public_path__ + "static/media/Untitledq@2x.91bf37b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Untitledq@2x.png
// module id = 572
// module chunks = 1